/*@flow*/
import Context from './context';
import commands from './commands';
import { useContext } from 'react';

export default function useCommands() {
  const ctx = useContext(Context);
  return commands(ctx);
}
